(function () {
  "use strict";

  var CACHE_KEY = "geo-block:country";
  var UNKNOWN = "unknown";
  var TRACKING_TAGS = {
    SCRIPT: true,
    NOSCRIPT: true,
    TEMPLATE: true,
    STYLE: true,
    LINK: true
  };

  var doc = document.documentElement;
  var config = window.geoBlockConfig;

  if (!config || !config.enabled) {
    reveal();
    return;
  }

  var params = new URLSearchParams(window.location.search);
  var debug = params.get("geo_block_debug") === "1";
  var timeoutMs = config.timeoutMs || 2000;

  // Only ever makes blocking stricter, so it is safe to expose publicly.
  if (params.get("geo_block_test") === "1") {
    renderBlockPage();
    return;
  }

  var cached = readCache();

  if (cached) {
    resolve(cached);
    return;
  }

  lookupCountry()
    .then(function (country) {
      writeCache(country);
      resolve(country);
    })
    .catch(function (error) {
      if (debug) {
        console.warn("[geo-block] lookup failed:", error);
      }

      reveal();
    });

  function lookupCountry() {
    var controller =
      typeof AbortController === "function" ? new AbortController() : null;
    var timer = controller
      ? window.setTimeout(function () {
          controller.abort();
        }, timeoutMs)
      : null;

    function clear() {
      if (timer) {
        window.clearTimeout(timer);
      }
    }

    return fetch(config.lookupUrl, {
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        clear();

        if (!response.ok) {
          throw new Error("Geo lookup failed with status " + response.status);
        }

        var contentType = response.headers.get("content-type") || "";

        if (contentType.indexOf("application/json") === -1) {
          throw new Error(
            "Geo lookup returned non-JSON content. Unlock the password-protected store first."
          );
        }

        return response.json();
      })
      .then(function (data) {
        var detected =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;

        return detected || UNKNOWN;
      })
      .catch(function (error) {
        clear();
        throw error;
      });
  }

  function resolve(country) {
    if (debug) {
      console.info("[geo-block] country:", country);
    }

    if (isBlocked(country)) {
      renderBlockPage();
      return;
    }

    reveal();
  }

  function isBlocked(code) {
    var normalized = String(code).toUpperCase();

    return (config.blockedCodes || []).some(function (entry) {
      return String(entry).trim().toUpperCase() === normalized;
    });
  }

  function readCache() {
    try {
      return window.sessionStorage.getItem(CACHE_KEY) || "";
    } catch (error) {
      return "";
    }
  }

  function writeCache(country) {
    try {
      window.sessionStorage.setItem(CACHE_KEY, country);
    } catch (error) {
      /* Private mode or storage disabled: fall back to one lookup per page. */
    }
  }

  function reveal() {
    doc.classList.remove("geo-block-pending");
  }

  function renderBlockPage() {
    var strings = config.strings || {};

    doc.classList.remove("geo-block-pending");
    doc.classList.add("geo-block-active");
    document.title = [strings.pageTitle, strings.brand]
      .filter(Boolean)
      .join(" | ");
    setNoIndex();

    whenBodyReady(function (body) {
      // Strip visible content but keep analytics nodes in place: removing the
      // Web Pixels sandbox makes Shopify re-inject it and re-fire page_viewed.
      Array.prototype.slice.call(body.children).forEach(function (node) {
        if (!isTrackingNode(node)) {
          body.removeChild(node);
        }
      });

      body.classList.add("geo-block-page");
      body.appendChild(buildScreen(strings));
    });
  }

  function setNoIndex() {
    var robots = document.querySelector('meta[name="robots"]');

    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }

    robots.setAttribute("content", "noindex, nofollow");
  }

  function isTrackingNode(node) {
    if (TRACKING_TAGS[node.tagName]) {
      return true;
    }

    var id = node.id || "";

    return id.indexOf("web-pixels") !== -1 || id.indexOf("shopify-") === 0;
  }

  function whenBodyReady(callback) {
    if (document.body) {
      callback(document.body);
      return;
    }

    document.addEventListener("DOMContentLoaded", function () {
      callback(document.body);
    });
  }

  function buildScreen(strings) {
    var main = document.createElement("main");

    main.className = "geo-block-page__main";
    main.appendChild(textNode("p", "geo-block-page__brand", strings.brand));
    main.appendChild(textNode("h1", "geo-block-page__heading", strings.heading));
    main.appendChild(textNode("p", "geo-block-page__message", strings.message));

    return main;
  }

  function textNode(tag, className, text) {
    var element = document.createElement(tag);

    element.className = className;
    element.textContent = text || "";

    return element;
  }
})();
